/**
 * Created by iamso on 16.11.2021
 */

const LockedComponent = function (unit, options) {
    UnitComponent.call(this, unit);

    const data = this.unit.getData();

    this.unlockDuration = cleverapps.parseInterval(data.lockable.duration);

    this.load(options);
};

LockedComponent.prototype = Object.create(UnitComponent.prototype);
LockedComponent.prototype.constructor = LockedComponent;

LockedComponent.prototype.load = function (data) {
    if (data.lockTime === 0 || data.lockTime === undefined && !data._fromSave) {
        this.lock();
    } else if (data.lockTime > 0) {
        this.lock();
        this.startUnlocking(data.lockTime);
    }
};

LockedComponent.prototype.save = function (data) {
    if (this.isLocked()) {
        data.lockTime = this.lockTime;
    }
};

LockedComponent.prototype.isLocked = function () {
    return this.lockTime !== undefined;
};

LockedComponent.prototype.isUnlocking = function () {
    return this.lockTime > 0;
};

LockedComponent.prototype.startUnlocking = function (lockTime = Date.now()) {
    if (!this.isLocked() || this.isBlocked()) {
        return;
    }

    this.lockTime = lockTime;
    const timeLeft = this.getTimeLeft();

    if (timeLeft > 0) {
        LockedComponent.unlocking = this;

        this.lockTimeout = new cleverapps.LongTimeout(this.unlock.bind(this), timeLeft);
        this.unit.save();
        PushHelper.sendPush(PUSHES.UNITLOCK_OPEN, timeLeft);
        if (this.view) {
            this.view.restoreState();
        }

        if (Merge2.current.field.selectedUnit === this.unit) {
            Merge2.current.field.updateUnitSelection();
        }

        LockedComponent.refreshViews();
    } else {
        this.unlock();
    }
};

LockedComponent.prototype.lock = function () {
    if (this.isLocked()) {
        return;
    }

    this.lockTime = 0;
    this.unit.save();
    if (this.view) {
        this.view.restoreState();
    }
};

LockedComponent.prototype.unlock = function () {
    if (!this.isLocked()) {
        return;
    }

    delete this.lockTime;
    if (this.lockTimeout) {
        clearTimeout(this.lockTimeout);
        delete this.lockTimeout;
    }
    if (LockedComponent.unlocking === this) {
        delete LockedComponent.unlocking;
    }
    this.unit.save();
    if (this.view) {
        this.view.restoreState();
    }

    LockedComponent.updateSelection();

    LockedComponent.refreshViews();
};

LockedComponent.prototype.isBlocked = function () {
    const unlocking = LockedComponent.findUnlocking();
    return Boolean(unlocking && unlocking !== this);
};

LockedComponent.prototype.getTimeLeft = function () {
    const timePassed = Date.now() - this.lockTime;
    return Math.max(0, this.unlockDuration - timePassed);
};

LockedComponent.prototype.getSpeedUpOptions = function () {
    return {
        timeLeft: this.getTimeLeft(),
        totalDuration: this.unlockDuration,
        eventName: cleverapps.EVENTS.SPENT.UNLOCK,
        callback: this.unlock.bind(this),
        source: this.unit.onGetView()
    };
};

LockedComponent.prototype.destructor = function () {
    const wasUnlocking = this.isUnlocking();

    if (this.lockTimeout) {
        clearTimeout(this.lockTimeout);
        delete this.lockTimeout;
    }
    if (LockedComponent.unlocking === this) {
        delete LockedComponent.unlocking;
    }

    if (wasUnlocking) {
        LockedComponent.refreshViews();
        LockedComponent.updateSelection();
    }
};

LockedComponent.findUnlocking = function () {
    const field = Merge2.current.field;

    const unlocking = LockedComponent.unlocking;
    if (unlocking && unlocking.isUnlocking() && field.getUnit(unlocking.unit.x, unlocking.unit.y) === unlocking.unit) {
        return unlocking;
    }
    delete LockedComponent.unlocking;

    for (let y = 0; y < field.height; y++) {
        for (let x = 0; x < field.width; x++) {
            const unit = field.units[y][x];
            const locked = unit && unit.findComponent(LockedComponent);
            if (locked && locked.isUnlocking()) {
                LockedComponent.unlocking = locked;
                return locked;
            }
        }
    }
};

LockedComponent.updateSelection = function () {
    const field = Merge2.current && !Merge2.current.stopped && Merge2.current.field;
    const selected = field && !field.stopped && field.selectedUnit;
    if (selected && selected.findComponent(LockedComponent)) {
        field.updateUnitSelection();
    }
};

LockedComponent.refreshViews = function () {
    Merge2.current.field.iterateUnits((x, y, unit) => {
        const locked = unit.findComponent(LockedComponent);
        if (locked && locked.view) {
            locked.view.restoreState();
        }
    });
};